

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"evenodd","d":"M11 21.75c5.93 0 10.75-4.82 10.75-10.75S16.93.25 11 .25.25 5.07.25 11 5.07 21.75 11 21.75Zm0-1.5c-5.1 0-9.25-4.15-9.25-9.25S5.9 1.75 11 1.75 20.25 5.9 20.25 11 16.1 20.25 11 20.25Zm.38-12.33c.12-.05.23-.12.33-.21.09-.1.16-.21.21-.33.05-.12.08-.25.08-.38s-.03-.26-.08-.38c-.05-.13-.12-.23-.21-.33-.1-.09-.21-.16-.33-.21A.995.995 0 0 0 11 6c-.13 0-.26.03-.38.08s-.23.12-.33.21c-.09.1-.16.2-.21.33-.05.12-.08.25-.08.38s.03.26.08.38.12.23.21.33c.1.09.21.16.33.21.24.1.52.1.76 0ZM11 15.75c.41 0 .75-.34.75-.75v-5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v5c0 .41.34.75.75.75Z"}, []), "\n"]);
};

        